import { Box } from "@mui/material";
import content from "./../assets/content.json";


function Complete({language}) {
  const currentLanguage = content[language]["content"]

  return (
    <Box
      sx={{
        color: "#FFC627",
        textAlign: "center",
        fontSize: "26px",
        mt: 10,
      }}
    >
      {currentLanguage["complete"]}
    </Box>
  );
}

export default Complete;
